module.exports = __webpack_public_path__ + "img/bg.f0e71a75.png";